'use client';

import React from 'react';
import { Swiper, SwiperSlide } from 'swiper/react';
import { Autoplay } from 'swiper/modules';
import 'swiper/css';
import 'swiper/css/autoplay';
import Link from 'next/link';
import NextImage from '@/features/Image';

const ShopByConcernSlider = ({
  concerns,
}: {
  concerns: {
    id: number;
    title: string;
    slug: string;
    banner: string;
  }[];
}) => {
  return (
    <div className="concern-slider">
      <Swiper
        modules={[Autoplay]}
        spaceBetween={8}
        slidesPerView={3}
        speed={500}
        loop
        autoplay={{
          delay: 3000,
          disableOnInteraction: false,
        }}
        breakpoints={{
          576: { slidesPerView: 3, spaceBetween: 16 },
          768: { slidesPerView: 3 },
          992: { slidesPerView: 4, spaceBetween: 24 },
          1200: { slidesPerView: 5 },
        }}
      >
        {concerns.map((item) => (
          <SwiperSlide key={item.id}>
            <div className="concern-card h-100">
              <Link
                href={`/shop?good_for=${item.slug}`}
                className="concern-card__link"
              >
                <div className="concern-card__image">
                  <NextImage
                    width={274}
                    height={366}
                    src={item?.banner}
                    alt={item?.title}
                    className="concern-card__img"
                    priority={false}
                  />
                </div>
                <h6 className="concern-card__title fw-medium">{item.title}</h6>
              </Link>
            </div>
          </SwiperSlide>
        ))}
      </Swiper>
    </div>
  );
};

export default ShopByConcernSlider;
